module.exports = __webpack_public_path__ + "static/media/virgin-logo.81722b44.jpg";